import React, {Component} from 'react';
require('./common.scss');
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class Notification extends Component {
    render() {
        const {notificationState} = this.props;
        return (
            <div id="notificationContainer" className={notificationState.notificationState ? 'show' : 'hidden'}>{notificationState.notifyMessage}</div>
        );
    }
}
function mapStateToProps(state) {
    return {
       notificationState: state.notificationState
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Notification);

